import Axios from "axios"
import moment from 'moment-timezone';

export default {
    namespaced: true,
    state: {
        holidays: []
    },
    getters: {
        holidays: state => {
            const holidays = [];
            for (const h of state.holidays) {
                h.m_date = moment(h.holiday_date);
                holidays.push(h);
            }
            return holidays;
        }
    },
    mutations: {
        SET_HOLIDAYS(state, holidays) {
            state.holidays = holidays;
        }
    },
    actions: {
        async getHolidays({
            commit
        }, {
            cate_id,
            year
        }) {
            year -= 543;
            const {
                data
            } = await Axios.get('/lotto-holidays/' + cate_id + '?year=' + year);
            if (data.success && data.success == true) {
                commit('SET_HOLIDAYS', data.data);
            }

            return data;
        },
        async createHoliday(context, {
            id,
            date
        }) {
            const {
                data
            } = await Axios.post('/lotto-holidays', {
                id,
                date
            });

            return data;
        },
        async deleteHoliday(context, id) {
            const {
                data
            } = await Axios.delete('/lotto-holidays/' + id);

            return data;
        }
    }
}